<template>
  <div>
    <ButtonGroup size="small">
      <Button type="primary" @click="handleOpenCreate">新增</Button>
    </ButtonGroup>
    <ButtonGroup size="small" class="ivu-ml-8">
      <Button
        type="success"
        :disabled="selectedIds.length < 1"
        @click="handleEnableMultiple"
      >
        启用
      </Button>
      <Button
        type="error"
        :disabled="selectedIds.length < 1"
        @click="handleForbiddenMultiple"
      >
        禁用
      </Button>
      <!-- <Button
        @click="handleDeleteMultiple"
        type="error"
        :disabled="selectedIds.length < 1"
      >
        删除
      </Button> -->
    </ButtonGroup>

    <div class="ivu-inline-block ivu-fr">
      <Tooltip
        class="ivu-ml"
        :content="tableFullscreen ? '退出全屏' : '全屏'"
        placement="top"
      >
        <i-link @click.native="handleFullscreen">
          <Icon
            :custom="
              tableFullscreen
                ? 'i-icon i-icon-exit-full-screen'
                : 'i-icon i-icon-full-screen'
            "
          />
        </i-link>
      </Tooltip>
      <Tooltip class="ivu-ml" content="刷新" placement="top">
        <i-link @click.native="handleRefresh">
          <Icon custom="i-icon i-icon-refresh" />
        </i-link>
      </Tooltip>
      <Dropdown trigger="click">
        <Tooltip class="ivu-ml" content="列设置" placement="top">
          <i-link>
            <Icon type="md-options" />
          </i-link>
        </Tooltip>
        <DropdownMenu slot="list">
          <div class="ivu-p-8">列展示</div>
          <Divider size="small" class="ivu-mt-8 ivu-mb-8" />
          <template v-for="item in columns">
            <li
              class="ivu-dropdown-item"
              :key="item.title"
              v-if="item.title"
              @click="item.show = !item.show"
            >
              <Checkbox v-model="item.show"></Checkbox>
              <span>{{ item.title }}</span>
            </li>
          </template>
        </DropdownMenu>
      </Dropdown>
    </div>

    <Table
      ref="table"
      :columns="tableColumns"
      :data="dataList"
      :loading="loading"
      class="ivu-mt"
      @on-select="handleSelect"
      @on-select-cancel="handleSelectCancel"
      @on-select-all="handleSelectAll"
      @on-select-all-cancel="handleClearSelect"
    >
      <template slot-scope="{ row }" slot="username">
        <!-- <Avatar shape="square" :src="row.avatar" v-if="row.avatar" /> -->
        <!-- <Avatar shape="square" icon="ios-person" v-else /> -->
        {{ row.username }}
      </template>
      <template slot-scope="{ row }" slot="status">
        <Badge v-if="row.status === 1" color="green" text="正常" />
        <Badge v-else-if="row.status === 0" color="yellow" text="待审" />
        <Badge v-else-if="row.status === -1" color="red" text="禁用" />
      </template>
      <template slot-scope="{ row }" slot="create_time">
        {{ datetimeFormat(row.create_time) }}
      </template>
      <template slot-scope="{ row }" slot="action">
        <ButtonGroup size="small">
          <Button type="primary" ghost @click="handleEdit(row.id)">
            编辑
          </Button>
          <Button type="success" ghost @click="handleOpenRoleModal(row.id)">
            角色
          </Button>
        </ButtonGroup>
      </template>
    </Table>

    <div class="ivu-mt ivu-text-center">
      <Page
        size="small"
        :total="dataTotal"
        :current.sync="page"
        :page-size-opts="[10, 20, 50, 100]"
        show-total
        show-sizer
        show-elevator
        :page-size="pagesize"
        @on-change="handleChangePage"
        @on-page-size-change="handleChangePageSize"
      />
    </div>

    <Drawer
      :styles="dataDrawer.styles"
      v-model="dataDrawer.show"
      :title="
        dataDrawer.type === 'edit'
          ? '编辑管理员'
          : dataDrawer.type === 'new'
          ? '添加管理员'
          : '管理员信息'
      "
      width="560"
      :before-close="handleCloseEdit"
      :transfer="false"
      :mask-closable="false"
    >
      <Form
        v-if="dataInfo && dataInfoFormReady"
        ref="dataInfoForm"
        :model="dataInfo"
        :rules="dataInfoRules"
        :disabled="dataDrawer.type === 'read'"
        label-position="top"
        label-colon
        hide-required-mark
      >
        <Row :gutter="32" v-if="dataDrawer.type !== 'new'">
          <Col span="10" class="ivu-text-center">
            <Avatar
              v-if="dataInfo.avatar"
              :size="64"
              shape="square"
              :src="dataInfo.avatar"
            />
            <Avatar v-else :size="64" shape="square" icon="ios-person" />
            <Upload
              v-if="dataDrawer.type === 'edit'"
              class="ivu-mt-8"
              action=""
              :show-upload-list="false"
              :format="['jpg', 'jpeg', 'git', 'png']"
              :before-upload="handleUploadAvatar"
            >
              <Button type="text">
                更换
                <Icon type="ios-create-outline" />
              </Button>
            </Upload>
          </Col>
          <Col span="14">
            <div>ID: {{ dataInfo.id }}</div>
            <div class="ivu-mt-8">登录次数: {{ dataInfo.signin_times }}</div>
            <div class="ivu-mt-8">
              注册时间:
              {{ datetimeFormat(dataInfo.create_time, 'YYYY-MM-DD HH:II:SS') }}
            </div>
            <div class="ivu-mt-8">
              最近登录时间:
              {{
                datetimeFormat(dataInfo.last_signin_time, 'YYYY-MM-DD HH:II:SS')
              }}
            </div>
          </Col>
        </Row>
        <Divider v-if="dataDrawer.type !== 'new'" />
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="username" label="用户名">
              <Input
                size="small"
                v-model="dataInfo.username"
                placeholder="请输入用户名"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="email" label="电子邮箱">
              <Input
                size="small"
                v-model="dataInfo.email"
                placeholder="请输入电子邮箱"
              />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="nickname" label="昵称">
              <Input
                size="small"
                v-model="dataInfo.nickname"
                placeholder="请输入昵称"
                maxlength="20"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem prop="password" label="密码">
              <Input
                size="small"
                v-model="dataInfo.password"
                placeholder="请输入密码(不填不修改)"
                maxlength="20"
              />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem prop="status" label="状态">
              <RadioGroup size="small" v-model="dataInfo.status">
                <Radio :label="1"><span>正常</span></Radio>
                <Radio :label="-1"><span>禁用</span></Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>

        <FormItem prop="remark" label="备注">
          <Input
            size="small"
            v-model="dataInfo.remark"
            placeholder="请输入备注"
          />
        </FormItem>
      </Form>
      <div class="page-sys-user-drawer-footer">
        <Button
          type="primary"
          @click="handleSubmitEdit"
          :loading="submitting"
        >
          提交
        </Button>
      </div>
    </Drawer>

    <Modal
      v-model="showRoleModal"
      title="角色分配"
      width="768"
      :mask-closable="false"
      footer-hide
    >
      <o-role
        ref="role"
        :admin-id="currentAdminId"
        @completed="handleCloseRoleModal"
      />
    </Modal>
  </div>
</template>

<script>
import { datetimeFormat } from '@/utils/datetime'
import api from '@/api'
// import { cloneDeep } from 'lodash'
import tableColumns from './table-columns'
import dataListMixin from '@/mixins/data-list'
import oRole from './role'

export default {
  data() {
    return {
      datetimeFormat,
      columns: tableColumns,

      dataInfoRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
      },

      showRoleModal: false,
      currentAdminId: 0,
    }
  },
  mixins: [dataListMixin],
  components: { oRole },
  methods: {
    // 取数据列表
    handleGetDataList() {
      if (this.loading) return
      this.loading = true

      // 下面的 params 是获取的表单查询参数
      const {
        keyword,
        status,
        page,
        // date,
      } = this.$parent.$parent.$refs.filter.params
      if (page) {
        this.page = page
        this.$parent.$parent.$refs.filter.params.page = null
      }
      api.rbac.admin
        .list({
          keyword,
          status,
          start_time: '',
          end_time: '',
          page: this.page, // 页数
          pagesize: this.pagesize, // 每页数量
        })
        .then((data) => {
          if (!data) return

          this.handleClearSelect()
          this.dataList = data.admin_list || []
          this.dataTotal = data.admin_total
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    // 取单一数据
    handleGetDataInfo(id) {
      if (this.loading) return
      this.loading = true

      // eslint-disable-next-line
      return new Promise((resolve, reject) => {
        api.rbac.admin
          .info({
            id,
          })
          .then((data) => {
            if (!data) return

            this.dataInfo = data.admin || null
            this.dataInfo.password = ''

            resolve()
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 批量启用
    handleEnableMultiple() {
      if (this.loading) return
      this.loading = true

      const ids = this.ids
      api.rbac.admin
        .enable({
          ids,
        })
        .then(() => {
          this.loading = false

          this.$Modal.remove()
          this.$Message.success('操作成功')
          // 完成后刷新数据
          // this.handleClearSelect()
          // this.handleChangePage(1)
          this.handleGetDataList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 批量封号
    handleForbiddenMultiple() {
      if (this.loading) return
      this.loading = true

      const ids = this.ids
      api.rbac.admin
        .forbidden({
          ids,
        })
        .then(() => {
          this.loading = false

          this.$Modal.remove()
          this.$Message.success('操作成功')
          // 完成后刷新数据
          // this.handleClearSelect()
          // this.handleChangePage(1)
          this.handleGetDataList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 批量删除
    handleDeleteMultiple() {
      const ids = this.ids
      this.$Modal.confirm({
        title: '删除确认',
        content: `删除后数据不可恢复，确定要删除所选数据项？`,
        loading: true,
        onOk: () => {
          if (this.loading) return
          this.loading = true

          api.rbac.admin
            .delete({
              ids,
            })
            .then(() => {
              this.loading = false

              this.$Modal.remove()
              this.$Message.success('操作成功')
              // 完成后刷新数据
              // this.handleClearSelect()
              // this.handleChangePage(1)
              this.handleGetDataList()
            })
            .catch(() => {
              this.loading = false
            })
        },
      })
    },
    // 单条删除
    handleDelete(id) {
      this.$Modal.confirm({
        title: '删除确认',
        content: `删除后数据不可恢复，确定要删除此项数据？`,
        loading: true,
        onOk: () => {
          if (this.loading) return
          this.loading = true

          api.rbac.admin
            .delete({
              ids: id,
            })
            .then(() => {
              this.loading = false

              this.$Modal.remove()
              this.$Message.success('操作成功')
              // 完成后刷新数据
              // this.handleClearSelect()
              // this.handleChangePage(1)
              this.handleGetDataList()
            })
            .catch(() => {
              this.loading = false
            })
        },
      })
    },
    // 编辑
    handleEdit(id) {
      this.handleGetDataInfo(id)
        .then(() => {
          this.dataInfoString = this.createDataInfoString(this.dataInfo)
          this.dataDrawer.type = 'edit'
          this.dataDrawer.show = true
          this.handleInitDataInfoForm()
        })
        .catch(() => {})
    },

    // 用户详情
    handleClickRow(row) {
      console.log('click row: row -> ')
      console.log(row)
      // this.dataInfo = cloneDeep(this.handleGetUser(row.id))
      // this.dataDrawer.type = 'read'
      // this.dataDrawer.show = true
      // this.handleInitDataInfoForm()
    },
    // 添加
    handleOpenCreate() {
      this.dataInfo = {
        id: 0,
        avatar: '',
        username: '',
        email: '',
        nickname: '',
        password: '',
        remark: '',
        status: 1,
      }

      this.dataInfoString = this.createDataInfoString(this.dataInfo)
      this.dataDrawer.type = 'new'
      this.dataDrawer.show = true
      this.handleInitDataInfoForm()
    },
    handleSubmitEdit() {
      this.$refs.dataInfoForm.validate((valid) => {
        if (valid) {
          if (this.loading) return
          if (this.submitting) return
          this.loading = true
          this.submitting = true

          const params = {
            id: this.dataInfo.id,
            username: this.dataInfo.username,
            email: this.dataInfo.email,
            nickname: this.dataInfo.nickname,
            avatar: this.dataInfo.avatar,
            password: this.dataInfo.password,
            remark: this.dataInfo.remark,
            status: this.dataInfo.status,
          }
          // console.log(params)
          api.rbac.admin
            .save(params)
            .then(() => {
              this.loading = false

              this.dataDrawer.show = false
              this.$Message.success('修改成功')
              this.handleGetDataList()
            })
            .catch(() => {
              this.loading = false
            })
            .finally(() => {
              this.submitting = false
            })
        }
      })
    },
    handleInitDataInfoForm() {
      this.dataInfoFormReady = false
      this.$nextTick(() => {
        this.dataInfoFormReady = true
      })
    },
    changePassword(id) {
      console.log(id)
    },

    handleUploadAvatar(file) {
      // if (file.size > 40960000) {
      //   return false
      // }

      let params = new FormData()
      params.append('image', file)
      params.append('width', 72)
      params.append('height', 72)

      api.upload.adminAvatar(params).then((data) => {
        this.dataInfo.avatar = data.url
      })

      return false
    },

    // 角色
    handleOpenRoleModal(id) {
      this.showRoleModal = true
      this.currentAdminId = id
      this.$nextTick(() => {
        this.$refs['role'].handleGetData()
      })
    },
    handleCloseRoleModal() {
      this.showRoleModal = false
      this.currentAdminId = 0
    },
  },
}
</script>
<style lang="scss">
.page-sys-user {
  &-drawer {
    &-footer {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      border-top: 1px solid #e8e8e8;
      padding: 10px 16px;
      text-align: right;
      background: #fff;
    }
    &-form {
      .ivu-input[disabled],
      fieldset[disabled] .ivu-input,
      .ivu-select-disabled .ivu-select-selection {
        background-color: #fff;
        color: inherit;
      }
      &-region {
        .i-region-transfer {
          width: 270px;
        }
        .i-region-drop-main {
          width: 270px !important;
          height: 200px;
          overflow: auto;
          column-count: 2;
          &-item {
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>
